import { IconX } from "@tabler/icons-react";

export interface EditorTabProps {
  readonly label: string;
  readonly isActive: boolean;
  readonly isDirty?: boolean;
  readonly hasExternalChange?: boolean;
  readonly onActivate: () => void;
  readonly onClose?: (() => void) | undefined;
  readonly title?: string;
}

export function EditorTab(props: EditorTabProps) {
  return (
    <div
      className={
        "group flex min-w-0 max-w-[200px] cursor-pointer items-center gap-1.5 border-r border-border px-3 py-1.5 text-xs " +
        (props.isActive
          ? "bg-background text-foreground"
          : "text-muted-foreground hover:bg-accent/40")
      }
      onClick={props.onActivate}
      title={props.title ?? props.label}
    >
      {props.hasExternalChange ? (
        <span
          className="inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-warning"
          aria-label="External change"
        />
      ) : null}
      <span className="truncate">{props.label}</span>
      {props.isDirty ? <span className="text-foreground/70">●</span> : null}
      {props.onClose ? (
        <button
          type="button"
          className="sidebar-icon-button ml-1 opacity-0 transition-opacity group-hover:opacity-100"
          onClick={(event) => {
            event.stopPropagation();
            props.onClose?.();
          }}
          aria-label={`Close ${props.label}`}
        >
          <IconX size={12} />
        </button>
      ) : null}
    </div>
  );
}
